// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__9_xm4","label":"Category_label__MnI4b","content":"Category_content__3Ff-I","header":"Category_header__3fNM1","location":"Category_location__3L2LP"};